/** Re-export from CommonJS source (shared with prebuild PDF script). */
import guide from "./claimRewardsPermissionGuideContent.cjs";

export const buildClaimRewardsPermissionGuideLines = guide.buildClaimRewardsPermissionGuideLines;
export const DEFAULT_GUIDE_PARAMS = guide.DEFAULT_GUIDE_PARAMS;
export const CLAIM_REWARDS_PERMISSION_NAME = guide.CLAIM_REWARDS_PERMISSION_NAME;
